<script>
import FormInputView, { FormInput } from './FormInput'

export var FormInputGroup = {
    util: function(getInputs) {
        return {
            get: function(key, inputs) {
                var i, ks, input;
                inputs = inputs || getInputs();
                if (Array.isArray(inputs)) {
                    return inputs.find((input) => (input.key == key));
                } else {
                    ks = Object.keys(inputs)
                    for (i = 0; i < ks.length; i++) {
                        input = this.get(key, inputs[ks[i]]);
                        if (input) {
                            return input;
                        }
                    }
                }
            },
            forEach: function(callback, inputs) {
                inputs = inputs || getInputs();
                if (Array.isArray(inputs)) {
                    inputs.forEach(callback);
                } else {
                    Object.keys(inputs).forEach((groupKey) => {
                        this.forEach(callback, inputs[groupKey]);
                    });
                }
            }
        };
    },
    makeInputs: function(inputsData) {
        var inputs;
        if (Array.isArray(inputsData)) {
            inputs = [];
            inputsData.forEach((inputData) => {
                inputs.push(FormInput.make(inputData));
            });
        } else {
            inputs = {};
            Object.keys(inputsData).forEach((groupKey) => {
                inputs[groupKey] = this.makeInputs(inputsData[groupKey]);
            });
        }
        return inputs;
    },
    makeValues: function(inputs, defaultValues, values) {
        values = values || {};
        if (Array.isArray(inputs)) {
            inputs.forEach((input) => {
                if (typeof defaultValues[input.key] != 'undefined') {
                    values[input.key] = defaultValues[input.key];
                } else {
                    values[input.key] = null;
                }
            });
        } else {
            Object.keys(inputs).forEach((groupKey) => {
                this.makeValues(inputs[groupKey], defaultValues, values);
            });
        }
        return values;
    }
};

export default {
    name: 'FormInputGroupView',
    components: {
        FormInputView
    },
    props: {
        inputs: Array,
        values: Object
    },
    computed:  {
        inputsVisible: function() {
            return this.inputs.flatMap((input) => { 
                if (input.visible) {
                    return [input];
                } else {
                    return [];
                }
            });
        }
    },
    methods: {
        update: function(key, value) {
            this.$emit('FormInputGroup:change', { key, value });
        }
    }
}
</script>

<template>
    <fieldset>
        <FormInputView
            v-for="input in inputsVisible"
            v-bind:key="input.key"
            v-bind:input="input"
            v-bind:value="values[input.key]"
            v-on:input="update(input.key, $event)"
        />
    </fieldset>
</template>
